import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import IconButtonTsoPq from '@components/Buttons/IconButtonTsoPq';
import TooltipTsoPq from '@components/Tooltip/TooltipTsoPq';
import { faTurnDown, faTurnUp } from '@fortawesome/free-solid-svg-icons';
import { Box, IconButtonProps, styled } from '@mui/material';

type CollapseButton = IconButtonProps & {
  expanded: boolean;
};

const StyledExpandButton = styled(IconButtonTsoPq, {
  shouldForwardProp: (prop) => prop !== 'expanded',
})<CollapseButton>(({ expanded }) => {
  return {
    borderRadius: tsoPqTheme.shape.border_radius_tso_border_radius_4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '2.125rem',

    ':hover': {
      background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_hover_lt,
    },

    '&:active': {
      outline: 'none',
    },

    '&:focus': {
      outline: 'none',
    },
  };
});

const CollapseButtonTsoPq = ({
  expanded,
  tooltip,
  setExpanded,
}: {
  expanded: boolean;
  tooltip: string;
  setExpanded: (expanded: boolean) => void;
}) => {
  return (
    <TooltipTsoPq title={tooltip}>
      <Box sx={{ display: 'flex' }}>
        <StyledExpandButton
          buttonType="outlinedPrimary"
          sizeVariant={'m'}
          icon={expanded ? faTurnUp : faTurnDown}
          expanded={expanded}
          onClick={() => setExpanded(!expanded)}
        /></Box>
    </TooltipTsoPq>
  );
};

export default CollapseButtonTsoPq;
